import { createFeature, createReducer, on } from '@ngrx/store';

import { AppActions } from './app.actions';
import { AppState, initialAppState } from './app.state';

export const appFeature = createFeature({
  name: 'app',
  reducer: createReducer(
    initialAppState,
    on(
      AppActions.init,
      (state): AppState => ({
        ...state,
        initialized: true,
      }),
    ),
  ),
});

export const { name: appFeatureKey, reducer: appReducer, selectInitialized } = appFeature;
